import React, { useState, useEffect } from 'react';
import Header from '../shared/Header';
import paz from '../assets/imgs/paz.png'

import linkedin from '../assets/icns/linkedin.svg'
import whatsapp from '../assets/icns/whatsapp.svg'

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); 


  return (
    <div className='container-fluid bg-light'>
      <div className="row mt-sm-4 mb-5">
      <div className='header-height'></div>
        <div className='col-sm-2 col-xs-12'></div>
        <div className='col-sm col-xs-12'>
      <div className='container'>
         <div className='row d-flex align-items-start pe-4'>
            <div className='col-md-9 col-xs-12 p-4'>

                <p className='mb-4 fw-300'>
                  Hey, I'm Paz. With over a decade of experience, I bring brands, products, stories, and experiences to life through the power of art, design, and technology. Recognized by leading tech companies, I specialize in 3D animation, frontend and backend development, and virtual reality — crafting immersive digital experiences that captivate, engage, and inspire.
                  I hold a Bachelor of Fine Arts (B.F.A.) in Animation and Game Development and a Master’s in Human-Computer Interaction (HCI) from well-recognized institutes. My expertise spans 3D animation, concept development, art direction, design, and web development, allowing me to create immersive, engaging, and impactful digital experiences.
                </p>

              <h5 className='mb-4'>
                My Journey
              </h5>

                <p className='mb-4 fw-300'>
                Since childhood, I've been deeply fascinated by drawing imaginary creatures and building wooden houses for cats after school. However, my journey hasn’t always been easy. During my primary school years, I faced bullying, which shaped my outlook on life and fueled my creative ambitions. I have also struggled with social anxiety for a significant part of my life, but I’ve learned to channel these personal experiences into inner strength, using them as motivation to prove that I am not the person my classmates once perceived me to be.
                In 2014, I took a major step by starting my own business and immersing myself in the animation industry. That same year, I also began my Bachelor’s degree in Animation, balancing both work and studies. Despite the challenges of managing academic responsibilities alongside my professional growth, this experience accelerated my learning. I dedicated my free time after classes to honing my skills, continuously pushing myself to evolve as both an artist and a creator.
                Beyond my passion for animation, I’m an avid fan of water sports—snowboarding in the winter, surfing in the summer, and cycling all year round. Creating animations and drawing remain at the heart of everything I do, fueling my creativity and artistic expression.
                My mission is to produce renowned animated films that tell my stories and leave audiences with thought-provoking messages and a lasting impact.
                </p>


              <h5 className='mb-4'>
                My Experience & Skills
              </h5>

                <p className='mb-4 fw-300'>
                Over the past 10+ years, I have worked with tech companies, service providers, and broadcasting networks, producing high-end multimedia content. My work includes:

                3D Animation & Motion Design – Producing stunning animated films and visual effects.
                Concept Development & Art Direction – Crafting unique visual styles and storytelling strategies.
                Web & Software Development – Creating interactive and engaging digital experiences.
                Human-Computer Interaction (HCI) & UX Design – Designing intuitive user experiences that enhance engagement.
                My ultimate goal is to produce films that bring personal experiences to life, leaving a lasting impact on audiences through visually stunning and thought-provoking narratives.
                </p>



              </div>
                <div className='col p-4'>
                    <img className='img-fluid border-bottom-dark' src={paz} alt="profile img"/>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
